import React from 'react';
import TemplatePageLeftContent from "../template_page/template_page_left_content/template_page_left_content";
import {NewsPageData} from "./news_page";
import Moment from "react-moment";
import "./news_page_left_content.scss";

class NewsPageLeftContent extends TemplatePageLeftContent<NewsPageData> {

    nearHeadlines(page: NewsPageData): React.ReactElement | React.ReactNodeArray | React.ReactPortal | undefined {
        if (page.created) {
            return <Moment className="news-date" date={page.created} format="DD MMMM YYYY"/>;
        }

        return undefined;
    }
}

export default NewsPageLeftContent;